export default __webpack_public_path__ + "static/media/ic_image.6a750a61.svg";